import { render, staticRenderFns } from "./patternDialog.vue?vue&type=template&id=0222ebcb&scoped=true"
import script from "./patternDialog.vue?vue&type=script&lang=js"
export * from "./patternDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0222ebcb",
  null
  
)

export default component.exports